import axios from '@/utils/request/index.js'

const lawyerInputData = async (body) => {
  try {
    const { data } = await axios.post('/sso/user/upLawyerLicense', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const lawOfficeInputData = async (body) => {
  try {
    const { data } = await axios.post('/org/update', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const enterpriseInputData = async (body) => {
  try {
    if (body.id == 0) {
      delete body.id
    }
    console.log('__body__', body)
    const { data } = await axios.post('/org/update', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const individualInputData = async (body) => {
  try {
    const { data } = await axios.post('/sso/user/upUserLicense', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const individual = async (body) => {
  try {
    const { data } = await axios.post('/sso/user/userAuth', {
      ...body,
    })
    return data.data
  } catch (error) {
    
    throw error
  }
}

const lawOfficeAuthOrgUrl = '/org/myAuthOrg'
const lawOfficeAuthOrg = async (body) => {
  try {
    const { data } = await axios.post(lawOfficeAuthOrgUrl, {
      ...body,
    })
    return { ...data.data.org, ...data.data.authRecord }
  } catch (error) {
    
    throw error
  }
}

const lawyerAuthOrgUrl = '/sso/user/lawyer/myLawyerAuth'
const lawyerAuthOrg = async (body) => {
  try {
    const { data } = await axios.post(lawyerAuthOrgUrl, {
      ...body,
    })
    
    return { ...data.data.user, ...data.data.lawyerAuth }
  } catch (error) {
    
    throw error
  }
}

export default {
  enterpriseInputData,
  individualInputData,
  lawyerInputData,
  lawOfficeInputData,
  individual,
  lawOfficeAuthOrg,
  lawyerAuthOrg,
  lawOfficeAuthOrgUrl,
}